module.exports = __webpack_public_path__ + "static/Galaxy.a6c7c6a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Galaxy/images/Galaxy.png
// module id = 336
// module chunks = 168707334958949